import { define } from 'wicked-elements'
import store from '../store'

/**
 * Listens to `active` state in the store, 
 * opens/closes based on this value
 * Functionality is enabled/disabled based on
 * viewport size (data-above)
 */

define('[data-component~="project"]', {
  init () {
    this.id = this.element.getAttribute('data-project')
    this.removeListener = null
    this.enabled = window.innerWidth >= this.element.dataset.above
    this.handleResize = this.handleResize.bind(this)
  },
  connected () {
    this.toggle(store.state.active) // init
    this.removeListener = store.listen(['active'], ({ active }) => {
      this.toggle(active)
    })
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('orientationchange', this.handleResize)
  },
  disconnected () {
    this.removeListener()
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('orientationchange', this.handleResize)
  },
  open () {
    this.element.classList.remove('closed')
    const bounding = this.element.getBoundingClientRect()
    if (bounding.top < 0 || bounding.bottom > window.innerHeight) {
      const alignToTop = store.state.scrollDirection === 'DOWN'
      this.element.scrollIntoView(alignToTop)
      // this.element.scrollIntoView(false)
    }
  },
  close () {
    this.element.classList.add('closed')
  },
  toggle (active) {
    if (this.enabled) {
      if (active === this.id) {
        this.open()
      } else {
        this.close()
      }  
    }
  },
  handleResize () {
    if (window.innerWidth >= this.element.dataset.above) {
      if (!this.enabled) {
        this.enabled = true
        this.toggle(store.state.active)  
      }
    } else {
      this.enabled = false
      // this.element.classList.remove('closed')
    }
  }
})